module.exports = __webpack_public_path__ + "img/icon_page_ll_off.9bf2c7a5.svg";